<template>
  <div>
    <b-overlay
      :show="loading"
      rounded="sm"
    >
      <b-row>
        <b-col
          md="12"
          class="mb-3 text-right"
        >
          <b-button
            class=""
            variant="outline-primarySpore"
            @click="showFilter"
          >
            <feather-icon
              icon="FilterIcon"
            />
            <span class="align-middle" v-if="!show"> Mostrar filtros </span>
            <span class="align-middle" v-else > Ocultar filtros </span>
          </b-button>
        </b-col>
      </b-row>
      <b-card no-body v-if="show">
        <b-card-header class="pb-50">
          <h5>
            Filtrar
          </h5>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col
              cols="12"
              xl="3"
              class="mb-md-0 mb-2"
            >
              <b-form-group
                label="Número de Contrato"
              >
                <b-form-input
                id="contract"
                v-model="filters.contract"
                @update="textTransform($event, 'contract')"
                placeholder="p. ej. 100000000"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              xl="3"
              class="mb-md-0 mb-2"
            >
              <b-form-group
                label="Número Medidor"
              >
                <b-form-input
                id="meterNumber"
                v-model="filters.meterNumber"
                @update="textTransform($event, 'meterNumber')"
                placeholder="p. ej. AAA001"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              xl="3"
              class="mb-md-0 mb-2"
            >
              <b-form-group
                label="Serie Spore"
              >
                <b-form-input
                id="serie"
                v-model="filters.serie"
                @update="textTransform($event, 'serie')"
                placeholder="p. ej. A224032860000001"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              xl="3"
              class="mb-md-0 mb-2"
            >
              <b-form-group
                label="Serie de tarjeta"
              >
                <b-form-input
                id="serieCard"
                v-model="filters.serieCard"
                @update="textTransform($event, 'serieCard')"
                placeholder="p. ej. SPORE SPOCHW00001 A00001 SC25 ó SPORE SPOCHW00001 A000000000000001 SC25"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              xl="3"
              class="mb-md-0 mb-2"
            >
            <b-form-group
                label="Estatus Instalación"
              >
                <b-form-select
                  id="installed"
                  v-model="filters.installed"
                  :options="[
                    { value: '1', text: 'Instalado' },
                    { value: '0', text: 'No instalado' }
                  ]"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              xl="3"
              class="mb-md-0 mb-2"
            >
            <b-form-group
                label="Transmisión"
              >
                <b-form-select
                  id="transmissionStatus"
                  v-model="filters.transmissionStatus"
                  :options="transmitionStatusOptions"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="userRole === 'A'"
              cols="12"
              xl="3"
              class="mb-md-0 mb-2"
            >
            <b-form-group
                label="Garantía"
              >
                <b-form-select
                  id="warrantyStatus"
                  v-model="filters.warrantyStatus"
                  :options="warrantyOptions"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              xl="10"
              class="text-right"
            >
              <b-form-group
                label="."
                style="color:#FFFFFF"
              >
                <b-button
                  variant="primarySpore"
                  @click="search"
                >
                  <feather-icon
                    icon="SearchIcon"
                    class="mr-50"
                  />
                  <span>Buscar</span>
                </b-button>
                <b-button
                  class="ml-1"
                  variant="danger"
                  @click="clear"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    class="mr-50"
                  />
                  <span>Limpiar</span>
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col md="6" class="mb-3 text-left">
              <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <label>{{ $t('Labels.Show') }}</label>
                <v-select v-model="params.limit" :options="this.perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" @input="getResponse"/>
                <label>{{ $t('Labels.Show') }}</label>
              </b-col>
            </b-col>
            <b-col md="6" class="mb-3 text-right">
              <b-button v-if="userRole !== 'S' && userRole !== 'I'" class="mr-1" variant="primarySpore" @click="goToRegisterMeter" v-b-tooltip.hover.top title="Registrar Medidor">
                <feather-icon icon="PlusCircleIcon" />
              </b-button>
              <b-button class="" variant="primarySpore" @click="goToInstallMeter" v-b-tooltip.hover.top title="Instalar Medidor">
                <feather-icon icon="ToolIcon" />
              </b-button>
            </b-col>
          </b-row>
          <b-row class="justify-content-between">
            <b-col cols="12" md="8" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <h4>Total de medidores: {{ totalRows }}</h4>
            </b-col>
            <b-row class="d-flex flex-row">
              <b-col cols="12" md="4" class="text-right mr-1" v-if="totalRows !== 0 && userRole === 'A'">
                <a @click="getMetersExport(true)" v-b-tooltip.hover.top title="Listado de Medidores Spore">
                    <feather-icon icon="DownloadCloudIcon" size="20" style="color:#dc2626"/>
                  </a>
              </b-col>
              <b-col cols="12" md="4" class="text-right mr-1" v-if="totalRows !== 0">
                <a @click="getMetersExport(false)" v-b-tooltip.hover.top title="Listado de Medidores">
                    <feather-icon icon="DownloadCloudIcon" size="20" />
                  </a>
              </b-col>
            </b-row>
          </b-row>
        </div>
        <div class="text-center" v-if="!this.response.length">
          No hay registros que mostrar
        </div>
        <b-table
          v-if="response.length"
          class="position-relative"
          hover
          responsive
          primary-key="id"
          show-empty
          empty-text="No matching records found"
          :items="response"
          :fields="tableColumns"
          no-local-sorting
          @sort-changed="handleSort"
        >
          <template #cell(contract)="data">
            <div class="text-nowrap selectable" @click="detail(data.item.uuid)" v-if="data.item.contract">
              <span class="align-text-top text-capitalize">{{ data.item.contract }}</span>
            </div>
          </template>
          <template #cell(meterNumber)="data">
            <div class="text-nowrap selectable" @click="detail(data.item.uuid)" v-if="data.item.meterNumber">
              <b-avatar
                v-if="data.item.meterNumber"
                size="32"
                class="avatar-border-2 box-shadow-1"
                variant="transparent"
              >
                <b-img :src="require(`@/assets/images/spore-icons/hash.svg`)" height="20"/>
              </b-avatar>
              <span class="align-text-top text-capitalize ml-1">{{ data.item.meterNumber }}</span>
            </div>
          </template>
          <template #cell(serie)="data">
            <div class="text-nowrap selectable" @click="detail(data.item.uuid)" v-if="data.item.serie">
              <b-avatar
                v-if="data.item.serie"
                size="32"
                class="avatar-border-2 box-shadow-1"
                variant="transparent"
              >
                <b-img :src="require(`@/assets/images/spore-icons/hash.svg`)" height="20"/>
              </b-avatar>
              <span class="align-text-top text-capitalize ml-1">{{ data.item.serie }}</span>
            </div>
          </template>
          <template #cell(serieCard)="data">
            <div class="text-nowrap selectable" @click="detail(data.item.uuid)" v-if="data.item.serieCard">
              <span class="align-text-top text-capitalize">{{ data.item.serieCard }}</span>
            </div>
          </template>
          <template #cell(energy)="data">
            <div class="text-nowrap selectable" @click="detail(data.item.uuid)">
              <b-avatar
                size="32"
                class="avatar-border-2 box-shadow-1"
                variant="transparent"
              >
                <b-img :src="require(`@/assets/images/spore-icons/energy.svg`)" height="20"/>
              </b-avatar>
              <span class="align-text-top text-capitalize ml-1">{{ data.item.energy || 0 }} KWh</span>
            </div>
          </template>
          <template #cell(status)="data">
            <div class="text-nowrap selectable" @click="detail(data.item.uuid)">
              <b-avatar
                size="32"
                class="avatar-border-2 box-shadow-1"
                :variant="data.item.transmissionStatusIndicator.color"
              >
                <feather-icon class="align-text-top" :icon="data.item.transmissionStatusIndicator.icon" size="18" />
              </b-avatar>
              <b>
                <span class="align-text-top ml-1" :class="`text-${data.item.transmissionStatusIndicator.color}`">
                  {{ data.item.transmissionStatusIndicator.message }}
                </span>
              </b>
            </div>
          </template>
          <template #cell(installedAt)="data">
            <div class="text-nowrap selectable" @click="detail(data.item.uuid)" v-if="data.item.installedAt">
              <span class="align-text-top text-capitalize">{{ data.item.installedAt }}</span>
            </div>
          </template>
          <template #cell(trasmitedAt)="data">
            <div class="text-nowrap selectable" @click="detail(data.item.uuid)" v-if="data.item.trasmitedAt">
              <b-avatar
                v-if="data.item.trasmitedAt"
                size="32"
                class="avatar-border-2 box-shadow-1"
                variant="transparent"
              >
                <b-img :src="require(`@/assets/images/spore-icons/fecha.svg`)" height="20"/>
              </b-avatar>
              <span class="align-text-top text-capitalize ml-1">{{ format(data.item.trasmitedAt) }}</span>
            </div>
          </template>
          <template #cell(relayState)="data">
            <div class="text-nowrap selectable" @click="detail(data.item.uuid)">
              <b-avatar
                size="32"
                class="avatar-border-2 box-shadow-1"
                :variant="data.item.relayState === '50' ? 'light-primary' : 'light-secondary'"
              >
              <feather-icon
                size="30"
                icon="PowerIcon"
              />
              </b-avatar>
              <span class="align-text-top text-capitalize ml-1">{{ data.item.relayState === '50' ? 'Abierto' : 'Cerrado'  }}</span>
            </div>
          </template>
          <template #cell(meterCommunication)="data">
            <div class="text-nowrap selectable" @click="detail(data.item.uuid)">
              <b-avatar
                size="32"
                class="avatar-border-2 box-shadow-1"
                :variant="data.item.meterCommunication.color"
              >
                <feather-icon class="align-text-top" :icon="data.item.meterCommunication.icon" size="18" />
              </b-avatar>
              <b>
                <span class="align-text-top ml-1" :class="`text-${data.item.meterCommunication.color}`">
                  {{ data.item.meterCommunication.message }}
                </span>
              </b>
            </div>
          </template>
          <template #cell(actions)="data">
            <div class='position-relative d-inline-block'>
              <!-- Botón -->
              <div
                class='avatar-border-2 box-shadow-1 d-flex justify-content-center align-items-center'
                style="width: 32px; height: 32px; border-radius: 100%; cursor: pointer;"
                @click.stop="toggleMenu(data.item.uuid)"
              >
                <feather-icon icon="MoreVerticalIcon" size="16" />
              </div>
              <!-- Menú -->
              <div
                v-if="openMenu === data.item.uuid"
                class="actions-menu"
              >
                <div
                  v-for="action in actions"
                  :key="action.label"
                  class="actions-item"
                  @click="handleAction(action, data.item)"
                >
                  {{ action.label }}
                </div>
              </div>
            </div>
          </template>
        </b-table>
        <!-- MODAL GARANTIA -->
        <b-modal
          v-model="showWarrantyModal"
          size="sm"
          centered
          hide-header-close
          no-close-on-esc
          no-close-on-backdrop
        >
          <template #modal-title>
            <h4>Gestión de Garantía</h4>
            <span>Medidor: <span class="text-plate">{{ selectedItem.meterNumber || selectedItem.serie }}</span></span>
          </template>

          <p class="text-dark">* Fecha</p>
          <b-form-group>
            <b-form-input
              type="date"
              :max="getToday()"
              v-model="warranty.date"
              :state="warrantyErrors.date ? false : null"
            />
            <b-form-invalid-feedback v-if="warrantyErrors.date">
              {{ warrantyErrors.date }}
            </b-form-invalid-feedback>
          </b-form-group>

          <p class="text-dark">* Comentario</p>
          <b-form-group>
            <b-form-textarea
              id="warranty-comment"
              v-model="warranty.comment"
              :state="warrantyErrors.comment ? false : null"
              placeholder="Ingresa un comentario"
              no-resize
              rows="3"
              maxlength="200"
            />
            <b-form-invalid-feedback v-if="warrantyErrors.comment">
              {{ warrantyErrors.comment }}
            </b-form-invalid-feedback>
          </b-form-group>

          <template #modal-footer="{ cancel }">
            <b-button variant="danger" @click="cancel">
              Cancelar
            </b-button>
            <b-button variant="primarySpore" @click="handleSaveWarranty">
              Actualizar
            </b-button>
          </template>
        </b-modal>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination v-model="currentPage" :total-rows="this.totalRows" :per-page="this.params.limit" first-class last-class class="mb-0 mt-1 mt-sm-0">
                <template #first-text>
                  <feather-icon icon="ChevronsLeftIcon" size="18"/>
                </template>
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18"/>
                </template>
                <template #last-text>
                  <feather-icon icon="ChevronsRightIcon" size="18"/>
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BButton, BTable, BPagination, VBTooltip, BFormGroup, BFormInput, BAvatar, BImg, BOverlay, BFormSelect, BFormTextarea, BFormInvalidFeedback
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import request from '@/libs/request/index'
import { formatDateLanguages, decimales } from '@/libs/tools/helpers'

const defaultFilters = {
  meterNumber: '',
  serie: '',
  serieCard: '',
  installed: '',
  transmissionStatus: '',
  warrantyStatus: '1', // <-- Default value (Sin Garantía)
  contract: ''
}

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BTable,
    BPagination,
    vSelect,
    BCardHeader,
    BFormGroup,
    BAvatar,
    BImg,
    BOverlay,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormInvalidFeedback
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  data () {
    return {
      // userRole: this.$store.state.session.AppActiveUser().userRole.toString(),
      show: false,
      loading: false,
      // tableColumns: [
      //   { key: 'contract', label: 'Contrato', sortable: true },
      //   { key: 'meterNumber', label: 'Número', sortable: true },
      //   { key: 'serie', label: 'Serie Spore', sortable: true },
      //   { key: 'serieCard', label: 'Serie de tarjeta', sortable: true },
      //   { key: 'energy', label: 'Energía', sortable: true },
      //   { key: 'status', label: 'Estatus Comunicación', sortable: true },
      //   { key: 'installedAt', label: 'Estado Instalación Medidor', sortable: true },
      //   { key: 'trasmitedAt', label: 'Última lectura', sortable: true },
      //   { key: 'relayState', label: 'Relevador', sortable: true },
      //   { key: 'meterCommunication', label: 'Comunicación de Tarjeta con Medidor', sortable: true },
      //   this.userRole === 'A' ? { key: 'actions', label: 'Acciones', sortable: false } : null
      // ].filter(Boolean),
      totalRows: 0,
      currentPage: 1,
      count: 0,
      perPageOptions: [10, 25, 50, 100],
      transmitionStatusOptions: [
        { value: '', text: 'Todos' },
        { value: '0', text: 'Transmitiendo' },
        { value: '1', text: 'Más de un día' },
        { value: '2', text: 'Sin transmitir' }
      ],
      warrantyOptions: [
        { value: '', text: 'Todos' },
        { value: '0', text: 'Con Garantía' },
        { value: '1', text: 'Sín Garantía' }
      ],
      response: [],
      responseExport: [],
      params: {
        limit: 20,
        offset: 0,
        byColumn: 'trasmitedAt',
        byOrder: 'desc',
        divisionUuid: this.$store.state.session.AppActiveUser().division.uuid
      },
      filters: {
        ...defaultFilters
      },
      urlDownload: '',
      openMenu: null,
      actions: [
        {
          label: 'Garantía',
          handler: (item) => this.openWarrantyModal(item)
        }
      ],
      showWarrantyModal: false,
      selectedItem: null,
      warranty: {
        date: this.getToday(),
        comment: ''
      },
      warrantyErrors: {
        date: '',
        comment: ''
      }
    }
  },
  methods: {
    decimal (val, n) {
      return decimales(val, n)
    },
    formValidateDate (date) {
      if (date === null) return '0'

      const date1 = new Date()
      const date2 = new Date(date)
      const diffTime = Math.abs(date2 - date1)

      let status = 2
      if (diffTime <= 86400000) {
        status = 1
      } else {
        status = 2
      }

      return status
    },
    calculateTransmissionStatusIndicator (status) {
      return {
        color: status === 0 ? 'success' : status === 1 ? 'warning' : 'secondary',
        message: status === 0 ? 'Transmitiendo' : status === 1 ? 'Más de un día' : 'Sin transmitir',
        icon: status === 0 ? 'ZapIcon' : 'ZapOffIcon'
      }
    },
    calculateTransmissionStatusMeter (status) {
      return {
        color: status === true ? 'success' : 'info',
        message: status === true ? 'SÍ' : 'NO',
        icon: status === true ? 'ZapIcon' : 'ZapOffIcon'
      }
    },
    async getResponse () {
      const filtersNotEmpty = Object.fromEntries(Object.entries(this.filters).filter(([_key, value]) => value !== ''))
      request({
        url: '/meters079',
        method: 'GET',
        params: { ...this.params, filters: JSON.stringify(filtersNotEmpty) }
      }).then(res => {
        this.response = res.data.data.rows.map(meter => ({
          uuid: meter.uuid,
          meterNumber: meter.meterNumber,
          serie: meter.serie,
          serieCard: meter.serieCard,
          meterCommunication: this.calculateTransmissionStatusMeter(meter.meterCommunication),
          contract: meter.contract ?? '',
          energy: meter.energy ?? '0',
          transmissionStatusIndicator: this.calculateTransmissionStatusIndicator(meter.transmissionStatus),
          trasmitedAt: meter.trasmitedAt,
          installedAt: meter.installedAt ? 'Instalado' : 'No instalado',
          meterWarranty: meter.meterWarranty || null,
          comment: meter.comment || null
        }))

        this.totalRows = res.data.data.count
        this.count = res.data.data.rows.length
      })
    },
    async handleSaveWarranty () {
      this.warrantyErrors = {
        date: '',
        comment: ''
      }

      let isValid = true

      if (!this.warranty.date) {
        this.warrantyErrors.date = 'La fecha es obligatoria'
        isValid = false
      } else {
        const today = this.getToday()

        if (this.warranty.date > today) {
          this.warrantyErrors.date = 'La fecha no puede ser futura'
          isValid = false
        }
      }

      if (!this.warranty.comment || this.warranty.comment.length < 5) {
        this.warrantyErrors.comment = 'Debe tener al menos 5 caracteres'
        isValid = false
      }

      if (!isValid) return

      try {
        const params = {
          url: '/meters079/warranty',
          method: 'POST',
          customMessages: true,
          params: {
            meterUuid: this.selectedItem.uuid,
            date: this.warranty.date,
            comment: this.warranty.comment
          }
        }

        await request(params)

        this.$swal({
          title: this.$t('Messages.Success'),
          text: this.$t('Messages.AddSuccess'),
          timer: 5000,
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-success'
          },
          buttonsStyling: false
        })

        // cerrar modal
        this.showWarrantyModal = false
        this.getResponse()
      } catch (error) {
        const code = error?.response?.data?.code

        if (code === 409) {
          this.$swal({
            title: this.$t('Messages.Fail'),
            text: this.$t('Messages.AlreadyExist'),
            icon: 'error'
          })
        } else if (code === 428) {
          this.$swal({
            title: this.$t('Messages.Fail'),
            text: this.$t('Messages.FailMessage'),
            icon: 'error'
          })
        } else if (code === 404 || code === 400) {
          this.$swal({
            title: this.$t('Messages.Fail'),
            text: this.$t('Messages.NotFound'),
            icon: 'error'
          })
        }
      }
    },
    showFilter () {
      this.show = !this.show
    },
    format (date) {
      return formatDateLanguages(date, 'hour')
    },
    detail (uuid) {
      this.$router.push(`/meters/GWH0079/${uuid}/detail`)
    },
    goToInstallMeter () {
      this.$router.push('/meters/GWH0079/install')
    },
    goToRegisterMeter () {
      this.$router.push('/meters/GWH0079/register')
    },
    search () {
      if (this.filters.meterNumber.length > 0 && this.filters.meterNumber.length !== 6) {
        this.$swal({
          title: 'Advertencia',
          text: 'Favor de agregar correctamente el Número de Medidor.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Aceptar',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1'
          }
        })
      } else if (this.filters.serie.length > 0 && this.filters.serie.length !== 16) {
        this.$swal({
          title: 'Advertencia',
          text: 'Favor de agregar correctamente la Serie Spore',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Aceptar',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1'
          }
        })
      } else if ((this.filters.serieCard.length > 0 && this.filters.serieCard.length !== 29) && (this.filters.serieCard.length > 0 && this.filters.serieCard.length !== 39)) {
        this.$swal({
          title: 'Advertencia',
          text: 'Favor de agregar correctamente la Serie de tarjeta.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Aceptar',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1'
          }
        })
      } else {
        this.params.offset = 0
        this.currentPage = 1
        this.getResponse()
      }
    },
    clear () {
      this.params.offset = 0
      this.currentPage = 1
      this.filters = { ...defaultFilters }
      this.getResponse()
    },
    async getMetersExport (complete) {
      const filtersNotEmpty = Object.fromEntries(Object.entries(this.filters).filter(([_key, value]) => value !== ''))
      request({
        url: '/meters079/export',
        method: 'GET',
        params: { divisionUuid: this.$store.state.session.AppActiveUser().division.uuid, filters: JSON.stringify(filtersNotEmpty) }
      }).then(res => {
        this.responseExport = res.data.data.rows
        this.createCsv(complete)
      })
    },
    createCsv (complete) {
      const headers = [
        'Numero Contrato',
        'Numero Medidor',
        'Modelo',
        'Lote',
        'Serie Tarjeta',
        'Serie Spore',
        'Energia (KWh)',
        'Estatus Comunicacion',
        'Estatus Instalacion del Medidor',
        'Relevador',
        'Fecha de Ultima Lectura',
        'Hora de Ultima Lectura',
        ...(complete
          ? ['Zona', 'Lat Spore', 'Long Spore', 'Lat Sinamed', 'Long Sinamed', 'Tipo de Comunicacion', 'Señal', 'Ruido', 'Garantía Oficio', 'Garantía Instalación', 'Comentario', 'Gateway', 'Última Fecha SporeWan', 'Última Fecha CatM1']
          : [])
      ]

      const csv = [headers.join(',')]

      for (let i = 0; i < this.responseExport.length; i++) {
        const meter = this.responseExport[i]
        const [, model, block] = meter.meterInstalled
          ? meter.meterInstalled.split(' ')
          : ''

        const communicationStatus = this.calculateTransmissionStatusIndicator(
          meter.transmissionStatus
        ).message
        const installationStatus = meter.installedAt
          ? 'Instalado'
          : 'No instalado'
        const transmissionDate = meter.trasmitedAt
          ? new Date(meter.trasmitedAt).toLocaleDateString()
          : undefined
        const transmissionTime = meter.trasmitedAt
          ? new Date(meter.trasmitedAt).toLocaleTimeString()
          : undefined
        const communicationType = meter?.red === 1 ? 'CatM1' : (meter?.red === 2 ? 'SporeWan' : '-')
        const row = []
        function wrap (value) {
          if (value === null || value === undefined || value === '') return '-'
          const str = value.toString()
          return `"""${str}"""`
        }
        const warrantyAt = meter.warrantyAt
          ? new Date(meter.warrantyAt).toLocaleDateString()
          : undefined
        const meterWarranty = meter.meterWarranty
          ? new Date(meter.meterWarranty).toLocaleDateString()
          : undefined
        const transmitedAtLoraDate = meter.transmitedAtLora
          ? new Date(meter.transmitedAtLora).toLocaleDateString() + ' ' + new Date(meter.transmitedAtLora).toLocaleTimeString()
          : undefined
        const transmitedAtCtm1Date = meter.transmitedAtCtm1
          ? new Date(meter.transmitedAtCtm1).toLocaleDateString() + ' ' + new Date(meter.transmitedAtCtm1).toLocaleTimeString()
          : undefined

        row.push(meter.contract)
        row.push(meter.meterNumber, model, block)
        row.push(meter.serieCard, meter.serie)
        row.push(meter.energy)
        row.push(communicationStatus)
        row.push(installationStatus)
        row.push(meter.relayState === '50' ? 'Abierto' : 'Cerrado')
        row.push(transmissionDate)
        row.push(transmissionTime)
        if (complete) {
          row.push(
            meter?.cfeZone?.name || '-',
            wrap(meter.lat),
            wrap(meter.long),
            wrap(meter.sinamed_lat),
            wrap(meter.sinamed_long),
            communicationType || '-',
            meter?.signal ? (meter?.signal?.replace(/,/g, '')) : '-',
            meter.lnsi || '-',
            warrantyAt || '-',
            meterWarranty || '-',
            wrap(meter.comment),
            meter?.gateway || '-',
            transmitedAtLoraDate || '-',
            transmitedAtCtm1Date || '-'
          )
        }
        csv.push(row.join(','))
      }
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)

      const descarga = document.createElement('a')
      descarga.href = this.urlDownload
      descarga.target = '_blank'
      descarga.download = complete ? 'Listado_Medidores_Spore.csv' : 'Listado_Medidores.csv'
      descarga.click()
    },
    textTransform (val, name) {
      this.filters[name] = val.toUpperCase()
    },
    handleSort ({ sortBy, sortDesc }) {
      if (sortBy === 'status') sortBy = 'trasmitedAt'
      this.params.byColumn = sortBy
      this.params.byOrder = sortDesc ? 'desc' : 'asc'
      this.getResponse()
    },
    toggleMenu (uuid) {
      this.openMenu = this.openMenu === uuid ? null : uuid
    },
    handleAction (action, item) {
      action.handler(item)
      this.openMenu = null
    },
    closeMenu () {
      this.openMenu = null
    },
    openWarrantyModal (item) {
      this.selectedItem = item

      this.warranty = {
        date: item.meterWarranty
          ? item.meterWarranty.slice(0, 10)
          : this.getToday(),
        comment: item.comment || ''
      }

      this.showWarrantyModal = true
    },
    getToday () {
      const today = new Date()
      const offset = today.getTimezoneOffset()
      const localDate = new Date(today.getTime() - offset * 60000)
      return localDate.toISOString().slice(0, 10)
    }
  },
  created () {
    this.getResponse()
  },
  watch: {
    currentPage (val) {
      this.params.offset = (val - 1) * this.params.limit
      this.getResponse()
    },
    byColumn (val) {
      this.params.byColumn = val
      this.currentx = 1
    }
  },
  mounted () {
    document.addEventListener('click', this.closeMenu)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeMenu)
  },
  computed: {
    userRole () {
      return this.$store.state.session.AppActiveUser().userRole.toString()
    },
    tableColumns () {
      return [
        { key: 'contract', label: 'Contrato', sortable: true },
        { key: 'meterNumber', label: 'Número', sortable: true },
        { key: 'serie', label: 'Serie Spore', sortable: true },
        { key: 'serieCard', label: 'Serie de tarjeta', sortable: true },
        { key: 'energy', label: 'Energía', sortable: true },
        { key: 'status', label: 'Estatus Comunicación', sortable: true },
        { key: 'installedAt', label: 'Estado Instalación Medidor', sortable: true },
        { key: 'trasmitedAt', label: 'Última lectura', sortable: true },
        { key: 'relayState', label: 'Relevador', sortable: true },
        { key: 'meterCommunication', label: 'Comunicación de Tarjeta con Medidor', sortable: true },
        this.userRole === 'A'
          ? { key: 'actions', label: 'Acciones', sortable: false }
          : null
      ].filter(Boolean)
    }
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .text-info {
    color: #dbdb00 !important
  }

  .badge-info {
    background-color: #dbdb00;
  }

  .actions-menu {
  position: absolute;
  bottom: -5px;
  right: 0;
  transform: translateY(100%);
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  padding: 4px 0;
  min-width: 140px;
  z-index: 20;
}

.actions-item {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
}

.actions-item:hover {
  background: #f5f5f5;
}
</style>
